export class Variants {
  async list() {}
  async get() {}
  async update() {}
  async delete() {}
}
